import React from "react";
import { IntlProvider, addLocaleData } from "react-intl";
// import locale_fa  from "react-intl/locale-data/fa";
import Message from "./locales/fa.json";


// addLocaleData(locale_fa);

const Locale = "fa";

class LanguageProvider extends React.Component {
  render() {
    return (
      <IntlProvider locale={Locale} messages={Message}>
          {React.Children.only(this.props.children)}
      </IntlProvider>
    );
  }
}

export default LanguageProvider;
